import jsStorage from 'js-storage'
// Local storage
window.$.localStorage = jsStorage.localStorage;